/* eslint-disable */
import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import DropdownMenu from "./DropdownMenu ";

export function SidebarLinks(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const activeColor = "#FFFFFF";
  const textColor = "rgba(255, 255, 255, 0.72)";
  const { routes } = props;

  const activeRoute = (routeName) => routeName && location.pathname.includes(routeName);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/admin/auth/sign-in");
  };

  const itemSx = (active) => ({
    spacing: "12px",
    py: "10px",
    px: "12px",
    mb: "4px",
    borderRadius: "12px",
    bg: active ? "rgba(139, 225, 90, 0.16)" : "transparent",
    border: "1px solid",
    borderColor: active ? "rgba(139, 225, 90, 0.28)" : "transparent",
    _hover: { bg: active ? "rgba(139, 225, 90, 0.2)" : "rgba(255, 255, 255, 0.06)" },
    transition: "background 0.15s ease, border-color 0.15s ease",
  });

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <React.Fragment key={index}>
            <Text
              fontSize="11px"
              color="rgba(255,255,255,0.45)"
              fontWeight="600"
              letterSpacing="0.08em"
              textTransform="uppercase"
              px="12px"
              pt="16px"
              pb="8px"
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </React.Fragment>
        );
      } else if (route.subRoutes) {
        return <DropdownMenu key={index} route={route} />;
      } else if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        if (route.path === "/logout") {
          return (
            <Box key={index} onClick={handleLogout} cursor="pointer">
              <HStack {...itemSx(false)}>
                <Box color={textColor} lineHeight="0">
                  {route.icon}
                </Box>
                <Text me="auto" color={textColor} fontSize="14px" fontWeight="400">
                  {route.name}
                </Text>
              </HStack>
            </Box>
          );
        }

        const active = activeRoute(route.path?.toLowerCase());
        return (
          <NavLink key={index} to={route.layout + route.path}>
            <HStack {...itemSx(active)}>
              <Box color={active ? "#8BE15A" : textColor} lineHeight="0">
                {route.icon}
              </Box>
              <Text
                me="auto"
                color={active ? activeColor : textColor}
                fontSize="14px"
                fontWeight={active ? "500" : "400"}
                noOfLines={1}
              >
                {route.name}
              </Text>
            </HStack>
          </NavLink>
        );
      }
      return null;
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
